import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "user-remark-container" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "v" }
const _hoisted_4 = { class: "time-outer" }
const _hoisted_5 = { class: "time" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "empty"
}
const _hoisted_8 = {
  key: 2,
  class: "loading"
}
const _hoisted_9 = { class: "footer" }
const _hoisted_10 = { class: "remark-form-box" }
const _hoisted_11 = { class: "textarea-box" }
const _hoisted_12 = { class: "character-box" }

import { queryCustomerRemarkApi, addCustomerRemarkApi, editCustomerRemarkApi } from '@/utils/user';
import { ref, watchEffect } from 'vue';
import Dialog from '@/TUIKit/components/common/Dialog';
import { Toast, TOAST_TYPE } from '@/TUIKit/components/common/Toast';
import pagination from './pagination.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'remarks',
  props: {
    userDetail: {}
  },
  setup(__props: any) {

const showRemarkDialog = ref(false)

const props = __props

const form = ref({
  remarkV: '',
  id: ''
})


const currentPage = ref(1)
const pageSize = ref(10)
const total = ref(0)


const loading = ref(false);
const remarksList:any = ref([]);

const getRemarkList = async ()=>{
	try {
		loading.value = true;
		const res:any = await queryCustomerRemarkApi({
			"pageNum": currentPage.value,
      "pageSize": pageSize.value,
      "customerId": props.userDetail.id
		})
		remarksList.value = res.body ? res.body.list: [];
    total.value = res?.body?.count || 0;
		console.log(remarksList.value, "popopop");
		
	} catch (err:any) {
		console.log(err);
	}finally{
		loading.value = false;
	} 
}

const handleCurrentChange = (val: number) => {
  currentPage.value = val
  getRemarkList()	
}
const handleSizeChange = (val: number) => {
  pageSize.value = val
  getRemarkList()	
}

const updateTextareaHeight = (event: any)=> {
  event.target.style.height = 'auto'
  event.target.style.height = `${event.target.scrollHeight}px`
}

watchEffect(()=>{
	loading.value = true;
  if(props.userDetail.id){
	  getRemarkList()
  }	
})

const addRemark = ()=>{ 
	showRemarkDialog.value = true;
}
const submit = async ()=>{
  try {
    if(!form.value.remarkV){
      Toast({
        message: '请填写备注信息',
        type: TOAST_TYPE.ERROR,
      });
      return
    }
    if (form.value.id) {
      const res:any = await editCustomerRemarkApi({
        "remark": form.value.remarkV,
        "id": form.value.id,
        "customerId": props.userDetail.id
      })
    } else {
      const res:any = await addCustomerRemarkApi({
        "remark": form.value.remarkV,
        "customerId": props.userDetail.id
      })
    }
		Toast({
      message: form.value.id ? '编辑成功' : '新增成功',
      type: TOAST_TYPE.SUCCESS,
    });

    getRemarkList()
		showRemarkDialog.value = false;
		form.value.remarkV = '';
    form.value.id = '';
	} catch (err:any) {
		console.log(err);
	}
}

const editRemark = (item:any)=>{
  console.log(item, "item");
  showRemarkDialog.value = true;
  form.value.remarkV = item.remark;
  form.value.id = item.id;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "header" }, [
      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text" }, "备注信息", -1)),
      _createElementVNode("span", {
        class: "add",
        onClick: addRemark
      }, "新增备注")
    ]),
    (remarksList.value.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "body",
          style: _normalizeStyle({height: remarksList.value.length ? '64px' : 0 })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(remarksList.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item",
              key: item
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(item.remark), 1),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(item.createTime), 1),
                  _createElementVNode("div", {
                    class: "edit",
                    onClick: ($event: any) => (editRemark(item))
                  }, "编辑", 8, _hoisted_6)
                ])
              ])
            ]))
          }), 128))
        ], 4))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, "暂无备注信息")),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, "加载中..."))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      (remarksList.value.length)
        ? (_openBlock(), _createBlock(pagination, {
            key: 0,
            "current-page": currentPage.value,
            "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
            "page-size": pageSize.value,
            "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageSize).value = $event)),
            total: total.value,
            "page-sizes": [10, 20, 30, 40],
            layout: "total, sizes, prev, pager, next, jumper",
            background: true,
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["current-page", "page-size", "total"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Dialog), {
      show: showRemarkDialog.value,
      title: form.value.id ? '编辑备注' : '新增备注',
      onSubmit: submit,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (showRemarkDialog.value = false)),
      noAutoCloseDialog: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "field" }, "备注名:", -1)),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.remarkV) = $event)),
              rows: "5",
              maxlength: "800",
              onInput: updateTextareaHeight,
              style: {"resize":"none"}
            }, null, 544), [
              [_vModelText, form.value.remarkV]
            ]),
            _createElementVNode("span", _hoisted_12, _toDisplayString(form.value.remarkV.length) + "/" + _toDisplayString(800), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["show", "title"])
  ]))
}
}

})